import {
  Flashcard,
  FlashcardContent,
  FlashcardsState,
} from '../types/Flashcard';

const normalizeVariant = (
  variant: FlashcardContent,
  fallbackIndex: number
): FlashcardContent => ({
  ...variant,
  id: variant.id ?? variant.variantId,
  variantId: variant.variantId ?? variant.id,
  ord: variant.ord ?? variant.versionNum ?? fallbackIndex,
  versionNum: variant.versionNum ?? variant.ord ?? fallbackIndex,
  original: variant.original ?? variant.front,
});

export const getFlashcardVariants = (
  flashcard?: Pick<Flashcard, 'variants'> | null
): FlashcardContent[] => {
  if (!flashcard) return [];
  const source = flashcard.variants ?? [];
  return source.map((variant, index) => normalizeVariant(variant, index));
};

export const normalizeFlashcard = (flashcard: Flashcard): Flashcard => {
  const normalizedVariants = getFlashcardVariants(flashcard);
  return {
    ...flashcard,
    variants: normalizedVariants,
  };
};

export const normalizeFlashcardsState = (
  flashcardsState: FlashcardsState
): FlashcardsState => ({
  ...flashcardsState,
  new: (flashcardsState.new ?? []).map(normalizeFlashcard),
  due: (flashcardsState.due ?? []).map(normalizeFlashcard),
  completed: (flashcardsState.completed ?? []).map(normalizeFlashcard),
});
